import { render, staticRenderFns } from "./shopOrderList.vue?vue&type=template&id=2a881bba&scoped=true&"
import script from "./shopOrderList.vue?vue&type=script&lang=js&"
export * from "./shopOrderList.vue?vue&type=script&lang=js&"
import style0 from "./shopOrderList.vue?vue&type=style&index=0&id=2a881bba&prod&lang=less&scoped=true&"
import style1 from "./shopOrderList.vue?vue&type=style&index=1&id=2a881bba&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a881bba",
  null
  
)

export default component.exports